export function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function isSafeUrl(url: string): boolean {
  return !/^(javascript:|data:)/i.test(url.trim());
}

function normalizeUrl(url: string): string {
  const trimmedUrl = url.trim();
  return trimmedUrl.startsWith('www.') ? `https://${trimmedUrl}` : trimmedUrl;
}

function countChar(text: string, char: string): number {
  let count = 0;

  for (let i = 0; i < text.length; i++) {
    if (text[i] === char) {
      count++;
    }
  }

  return count;
}

function splitTrailingPunctuation(rawUrl: string): { url: string; trailing: string } {
  let url = rawUrl;
  let trailing = '';

  while (url.length > 0) {
    const lastChar = url[url.length - 1];

    if (/[.,!?;:'"]/.test(lastChar)) {
      trailing = `${lastChar}${trailing}`;
      url = url.slice(0, -1);
      continue;
    }

    if (lastChar === ')' && countChar(url, '(') < countChar(url, ')')) {
      trailing = `)${trailing}`;
      url = url.slice(0, -1);
      continue;
    }

    if (lastChar === ']' && countChar(url, '[') < countChar(url, ']')) {
      trailing = `]${trailing}`;
      url = url.slice(0, -1);
      continue;
    }

    if (lastChar === '}' && countChar(url, '{') < countChar(url, '}')) {
      trailing = `}${trailing}`;
      url = url.slice(0, -1);
      continue;
    }

    break;
  }

  return { url, trailing };
}

export function formatMessage(text: string): string {
  if (!text) return '';

  const linkPlaceholders: string[] = [];
  const addLinkPlaceholder = (linkText: string, rawUrl: string): string => {
    const safeText = escapeHtml(linkText);
    const normalizedUrl = normalizeUrl(rawUrl);
    const safeUrl = escapeHtml(normalizedUrl);

    if (isSafeUrl(normalizedUrl)) {
      linkPlaceholders.push(
        `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer" style="color: #234EEE; text-decoration: underline;">${safeText}</a>`,
      );
    } else {
      linkPlaceholders.push(safeText);
    }

    return `%%LINK${linkPlaceholders.length - 1}%%`;
  };

  let textWithLinks = text.replace(/\[(.*?)\]\((.*?)\)/g, (_, textPart: string, rawUrl: string) =>
    addLinkPlaceholder(textPart, rawUrl),
  );

  textWithLinks = textWithLinks.replace(
    /(^|[\s([{<"'])((?:https?:\/\/|www\.)[^\s<]+)/gi,
    (_, prefix: string, rawUrl: string) => {
      const { url, trailing } = splitTrailingPunctuation(rawUrl);

      if (!url) {
        return `${prefix}${rawUrl}`;
      }

      return `${prefix}${addLinkPlaceholder(url, url)}${trailing}`;
    },
  );

  let safeText = escapeHtml(textWithLinks);

  for (let i = 0; i < linkPlaceholders.length; i++) {
    safeText = safeText.replace(`%%LINK${i}%%`, linkPlaceholders[i]);
  }

  return safeText
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/\n/g, '<br>');
}
